import deepmerge from 'deepmerge';

const createDefaultOverlayable = (zIndex: any) => ({
  // Ordered by level based on MUI defaults
  mobileStepper: { zIndex: zIndex.mobileStepper },

  appBar: { zIndex: zIndex.appBar },
  drawer: { zIndex: zIndex.drawer },
  modal: { zIndex: zIndex.modal },
  snackBar: { zIndex: zIndex.snackBar },
  tooltip: { zIndex: zIndex.tooltip }
});

const createGetOverlayable = (options: any) => (variant: any) => options[variant];

export const createOverlayable = (zIndex: any, overlayable = {}) => {
  const { getOverlayable: otherGetOverlayable, ...otherOptions }
      = typeof overlayable == 'function' ? overlayable(zIndex) : overlayable;
  const defaultOverlayable = createDefaultOverlayable(zIndex);
  const mergedOptions = deepmerge(defaultOverlayable, otherOptions, {
    clone: false
  });
  return {
    getOverlayable: otherGetOverlayable || createGetOverlayable(mergedOptions),
    ...mergedOptions
  };
};
